import { initAllFwnModules } from '@assets/fwnInit'
import { collectEntrypointConfig } from '@core/globalConfig'
import { ensureConsoleMethods } from '@core/helpers/ensureConsoleMethods'
import { yieldToMain } from '@core/helpers/yieldToMain'

async function main() {
  ensureConsoleMethods()
  collectEntrypointConfig()
  initAllFwnModules()

  // Import webcomponents so they
  // are bundled with fwn.js. Break the
  // components to individual tasks so they
  // won't cause long-running task warnings.
  await yieldToMain()
  require('../widget-element')
  await yieldToMain()
  require('../embed-feed-element')
  await yieldToMain()
  require('../storyblock-element')
  await yieldToMain()
  require('../player-element')
  await yieldToMain()
  require('../storylink-element')
  await yieldToMain()
  require('../herounit-element')
  await yieldToMain()
  require('../add-to-calendar-element')
  await yieldToMain()
  require('../share-element')
  await yieldToMain()
  require('../video-chat-element')
}

main()
